module.exports = __webpack_public_path__ + "img/not-found.4039141c.png";